module.exports = __webpack_public_path__ + "img/ostage_back2.9d9eb9de.png";